<mat-radio-group
  [(ngModel)]="countryAvailabilityStrategy"
  [ngModelOptions]="{ standalone: true }"
  class="example-radio-group"
  color="primary"
>
  <mat-radio-button
    value="blacklist"
    [matTooltip]="'ONSIP_I18N.ADD_ONLY_COUNTRIES_THAT_YOU_WANT_TO_BLOCK' | translate"
    matTooltipClass="onsip-tooltip-background"
    matTooltipPosition="right"
  >
    {{ "ONSIP_I18N.BLACKLIST" | translate }} ({{
      countryAvailabilityStrategy === "blacklist"
        ? formControl.value?.length
        : ("ONSIP_I18N.INACTIVE" | translate)
    }})
  </mat-radio-button>
  @if (countryAvailabilityStrategy === 'blacklist') {
  <div class="not-a-radio-button">
    <mat-form-field appearance="outline">
      <onsip-selection-list-deluxe disableRipple color="primary" [formControl]="formControl">
        @for (country of allCountries; track country) {
        <mat-list-option [value]="country" checkboxPosition="before">
          <onsip-avatar
            matListItemAvatar
            [name]="country.name"
            [avatarUrl]="country.avatarUrl"
          ></onsip-avatar>
          {{ country.name }}
        </mat-list-option>
        }
      </onsip-selection-list-deluxe>
    </mat-form-field>
  </div>
  }
  <mat-radio-button
    value="whitelist"
    [matTooltip]="'ONSIP_I18N.ADD_ONLY_COUNTRIES_THAT_YOU_WANT_TO_ALLOW' | translate"
    matTooltipClass="onsip-tooltip-background"
    matTooltipPosition="right"
  >
    {{ "ONSIP_I18N.WHITELIST" | translate }} ({{
      countryAvailabilityStrategy === "whitelist"
        ? formControl.value?.length
        : ("ONSIP_I18N.INACTIVE" | translate)
    }})
  </mat-radio-button>
  @if (countryAvailabilityStrategy === 'whitelist') {
  <div class="not-a-radio-button">
    <mat-form-field appearance="outline">
      <onsip-selection-list-deluxe disableRipple color="primary" [formControl]="formControl">
        @for (country of allCountries; track country) {
        <mat-list-option [value]="country" checkboxPosition="before">
          <onsip-avatar
            matListItemAvatar
            [name]="country.name"
            [avatarUrl]="country.avatarUrl"
          ></onsip-avatar>
          {{ country.name }}
        </mat-list-option>
        }
      </onsip-selection-list-deluxe>
    </mat-form-field>
  </div>
  }
</mat-radio-group>
